// extracted by mini-css-extract-plugin
export default {"empty":"style_empty__N3dtd","filled":"style_filled__pdUEo","mobileFilled":"style_mobileFilled__Gx94X","mobileEmpty":"style_mobileEmpty__Lhd6I"};